import {
  CLIENT_IMPORT_REASON,
  ClientImportSource,
  ClientImportStatus,
} from "@fitness-app/data-models/entities/ProductClientToImport";

export const IMPORT_ROW_STATUS_COLOR: Record<ClientImportStatus, string> = {
  [ClientImportStatus.Pending]: "default",
  [ClientImportStatus.Imported]: "green",
  [ClientImportStatus.Extended]: "green",
  [ClientImportStatus.Relinked]: "green",
  [ClientImportStatus.SkippedDuplicate]: "gold",
  [ClientImportStatus.Failed]: "red",
};

/** i18n key (under `products:import.reason`) for the machine reasons the backend writes; unknown ones show raw. */
const REASON_KEY: Record<string, string> = {
  [CLIENT_IMPORT_REASON.clientAlreadyExists]: "clientAlreadyExists",
  [CLIENT_IMPORT_REASON.noSourceAccess]: "noSourceAccess",
  [CLIENT_IMPORT_REASON.sourceProductNotFound]: "sourceProductNotFound",
  [CLIENT_IMPORT_REASON.wrongStatus]: "wrongStatus",
};

export const importReasonKey = (errorMessage: string | null): string | null =>
  errorMessage ? (REASON_KEY[errorMessage] ?? null) : null;

export const isKnownImportSource = (source: string): source is ClientImportSource =>
  Object.values<string>(ClientImportSource).includes(source);

export const importRowStatuses = Object.values(ClientImportStatus);
